export default __webpack_public_path__ + "static/media/avatar_siti4.ff23bdeb.mp3";